import { render, staticRenderFns } from "./UnitPowered.vue?vue&type=template&id=74bfc1b6&scoped=true&"
import script from "./UnitPowered.vue?vue&type=script&lang=js&"
export * from "./UnitPowered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfc1b6",
  null
  
)

export default component.exports